import React from 'react';
import useSubtheme from '../../hooks/useSubtheme';
import useComponentMargin from '../../hooks/useComponentMargin';
const Divider = ({ subtheme = ['regular', 'transparent'], noDefaultMargin = false, styles }) => {
    const { borderColor } = useSubtheme(subtheme);
    const componentMargin = useComponentMargin({ marginVertical: 'regular' });
    const mergedStyles = {
        ...(!noDefaultMargin && componentMargin),
        ...styles
    };
    return React.createElement("hr", { style: mergedStyles, color: borderColor });
};
export default Divider;
//# sourceMappingURL=index.js.map